export const getters = {
  systemGoodsreceiving: state => state.goodsreceiving,
  goodsitemsRows: state => state.goods_order_items,
  Goodreceiving: state => state.systemGoodreceiving,
  EditGoodsReceiving: state => state.good_receiving_items,
  GoodReceiving: state => state.systemGoodreceivings
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/goodsreceiving/getters.js